import React from 'react';
import { useTranslation } from '@shared/core';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { Palette } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';

export const GraphicAccentGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('graphicAccentCustomComponent');

  return (
    <SimpleGrabHandle
      title={tq`Graphic Accent`}
      subTitle={tq`Decorative accent for your page`}
      icon={<Palette size="lg" />}
      {...props}
    />
  );
};
